import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { IDocumentTemplate } from '@ispm/test/components/documents-tab/interfaces/document-template.interface';

@Component({
  selector: 'gen-documents-list',
  templateUrl: './documents-list.component.html',
  styleUrls: ['./documents-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentsListComponent implements OnInit {

  @ViewChild('list', {static: false}) list: ElementRef;
  @Input() documents: IDocumentTemplate[];
  @Output() selectedDocument: EventEmitter<IDocumentTemplate> = new EventEmitter();

  constructor() { }

  ngOnInit() {
    if (this.documents && this.documents.length > 0) {
      this.selectedDocument.emit(this.documents[0]);
    }
  }

  ngAfterViewInit() {
    if (this.list.nativeElement.children.length > 0) {
      this.selectDocument(true, 0);
    }
  }

  selectDocument(select: boolean, index: number) {
    if (select) {
      this.list.nativeElement.children[index].classList.add('selected');
    } else {
      this.list.nativeElement.children[index].classList.remove('selected');
    }
  }

  onSelectedItem(index: number) {
    for (let i = 0; i < this.list.nativeElement.children.length; i++) {
      if (i == index) {
        this.selectDocument(true, i);
        this.selectedDocument.emit(this.documents[i]);
      }
      else {
        this.selectDocument(false, i);
      }
    }
  }

}
